var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineTimer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76 22.75c-1.89 0-3.27-.79-3.8-2.15-.55-1.42-.04-3.18 1.28-4.37L10.88 12 6.24 7.77C4.92 6.58 4.41 4.82 4.96 3.4c.53-1.37 1.91-2.15 3.8-2.15h6.48c1.89 0 3.27.79 3.8 2.15.55 1.42.04 3.18-1.28 4.37L13.12 12l4.65 4.23c1.31 1.19 1.83 2.95 1.28 4.37-.54 1.36-1.92 2.15-3.81 2.15H8.76zm-1.51-5.42c-.84.77-1.21 1.89-.89 2.72.3.77 1.15 1.2 2.4 1.2h6.48c1.25 0 2.1-.42 2.4-1.2.32-.83-.04-1.95-.89-2.72L12 13.01l-4.75 4.32zM6.36 3.95c-.32.83.04 1.95.89 2.72L12 10.99l4.75-4.32c.84-.77 1.21-1.89.89-2.72-.3-.77-1.15-1.2-2.4-1.2H8.76c-1.25 0-2.1.42-2.4 1.2z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTimer2);
export default __webpack_public_path__ + "static/media/vuesax-outline-timer-2.316a4ef80a69c5cb27e2ebebfcf9323e.svg";
export { ForwardRef as ReactComponent };